@if ((loading$ | async) === false) { @if (building$ | async; as building) {
<div nav-header class="building-header">
  <div class="building-header-content">
    <div class="switcher">
      <sibat-selector
        [buildingId]="building.id"
        [count]="selectedBuildingsCount"
        (prevClicked)="navigateToBuilding($event, -1)"
        (nextClicked)="navigateToBuilding($event, +1)"
      >
      </sibat-selector>
    </div>
    <div class="address">
      <sibat-building-address [building]="building"></sibat-building-address>
    </div>
    @if (isBuildingStatusEnabled$ | async) {
    <div class="status">
      <span class="status-value">
        <span>
          @switch (building.status) { @case (buildingStatus.constructed) {
          <span class="subline">
            <mat-icon class="status-icon">engineering</mat-icon>
            {{ 'building.status.constructed' | transloco }}
          </span>
          } @case (buildingStatus.exploitation) {
          <span class="subline">
            <mat-icon class="status-icon">domain</mat-icon>
            {{ 'building.status.exploitation' | transloco }}
          </span>
          } @case (buildingStatus.project) {
          <span class="subline">
            <mat-icon class="status-icon">assignment</mat-icon>
            {{ 'building.status.project' | transloco }}
          </span>
          } @case (buildingStatus.underConstruction) {
          <span class="subline">
            <mat-icon class="status-icon">construction</mat-icon>
            {{ 'building.status.underConstruction' | transloco }}
          </span>
          } @case (buildingStatus.demolished) {
          <span class="subline">
            <mat-icon class="status-icon">domain_disabled</mat-icon>
            {{ 'building.status.demolished' | transloco }}
          </span>
          } }
        </span>
      </span>
    </div>
    }
  </div>
</div>
<sibat-side-nav class="align-side-nav" *transloco="let t; read: 'building'">
  <mat-nav-list nav-list>
    <a mat-list-item [routerLink]="['.']" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
      <mat-icon>info</mat-icon>
      <div mat-line>{{ t('overview.title') }}</div>
    </a>
    @if ((canBrowseDocuments$ | async) && authorizedForBuilding && (hasBuildingDocumentPolicy$ | async) === true) {
    <a mat-list-item [routerLink]="['documents']" routerLinkActive="active-link">
      <mat-icon>folder</mat-icon>
      <div mat-line>{{ t('documents.title') }}</div>
    </a>
    } @if ((hasBuildingDocumentPolicy$ | async) === true) {
    <a mat-list-item [routerLink]="['history']" routerLinkActive="active-link">
      <mat-icon>restore</mat-icon>
      <div mat-line>{{ t('history.title') }}</div>
    </a>
    } @if ((hasBuildingOverviewPolicy$ | async) && (isItechEnabled$ | async)) {
    <a
      mat-list-item
      [disabled]="((itechs$ | async)?.length ?? 0) === 0"
      [routerLink]="((itechs$ | async)?.length ?? 0) > 0 ? ['itech'] : null"
      routerLinkActive="active-link"
    >
      <mat-icon mat-list-icon>content_paste</mat-icon>
      <div mat-line>{{ t('technicalInstallation.tabTitle') }}</div>
    </a>
    } @if (hasBuildingOverviewPolicy$ | async) {
    <a
      mat-list-item
      [disabled]="((cases$ | async)?.length ?? 0) === 0"
      [routerLink]="((cases$ | async)?.length ?? 0) > 0 ? ['cases'] : null"
      routerLinkActive="active-link"
    >
      <mat-icon>hexagon</mat-icon>
      <div mat-line>{{ t('cases.casesInProgress') }}</div>
    </a>
    }
  </mat-nav-list>
</sibat-side-nav>
} @else {
<sibat-alert data-testid="sibat-no-building" type="warning">{{ 'building.notFound' | transloco }}</sibat-alert>
} } @else { }
